export const installationsCollectionLimit = 50;
